import {
  flow,
  split,
  compact,
  first,
  join,
  over,
  last,
  map,
  cond,
  size,
  eq,
  stubTrue,
  toUpper,
} from 'lodash/fp';

export const getInitials = (name: string | null) =>
  flow(
    split(' '),
    compact,
    cond([
      [flow(size, eq(1)), over([first])],
      [stubTrue, over([first, last])],
    ]),
    map(first),
    join(''),
    toUpper,
  )(name);
